import React from 'react';
import {SVGProps} from '@/types';
import {cn} from '@/utils';

interface ChevronRightIconProps extends SVGProps {
  className?: string;
}

const ChevronRightIcon = ({
  color = '#5E3B0A',
  width = 14,
  height = 15,
  className,
}: ChevronRightIconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(className)}>
      <g id="chevron-right">
        <path
          id="Vector"
          d="M5 11L8.5 7.5L5 4"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export default ChevronRightIcon;
